export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;

export const AUTHENTICATION_FAILURES = [UNAUTHORIZED, FORBIDDEN];
